import posthog from "posthog-js";

export const GENERATION_QUALITY_FLAG_KEY = "generation-quality-aug5";

export type GenerationQualityVariant =
  | "pre-aug5"
  | "aug5-bundle"
  | "explicit-style-control"
  | "explicit-style-anchor";

/**
 * Global rollback switch: only an explicit enabled/treatment value turns the
 * August-5 bundle on. Missing or unloaded flags stay on the pre-August-5
 * behavior, so legacy clients and first-session flag races cannot leak into
 * the rollout.
 */
export function generationQualityVariantForFlag(
  value: unknown,
): GenerationQualityVariant {
  return value === true || value === "aug5-bundle" ? "aug5-bundle" : "pre-aug5";
}

export const EXPLICIT_STYLE_CONSISTENCY_FLAG_KEY =
  "generation-explicit-style-consistency";

export function explicitStyleVariantForFlag(
  value: unknown,
  visualStyleId: unknown,
): GenerationQualityVariant {
  if (
    !["photo", "cinematic", "clean-illustration", "modern-graphic"].includes(
      String(visualStyleId),
    )
  ) {
    return "pre-aug5";
  }
  if (value === "treatment") return "explicit-style-anchor";
  if (value === "control") return "explicit-style-control";
  return "pre-aug5";
}

export function getGenerationQualityVariant(
  visualStyleId?: string,
): GenerationQualityVariant {
  const legacy = generationQualityVariantForFlag(
    posthog.getFeatureFlag(GENERATION_QUALITY_FLAG_KEY),
  );
  // Never mix two experiments in one generation.
  if (legacy === "aug5-bundle") return legacy;
  return explicitStyleVariantForFlag(
    posthog.getFeatureFlag(EXPLICIT_STYLE_CONSISTENCY_FLAG_KEY),
    visualStyleId,
  );
}
